import Cache from "../../utils/cache";

export const cacheRepurchaseGiftCardResultCode=response=>{
    console.log("@response",response)
    if(response?.result?.repurchaseGiftCardResultCode){
        Cache.set("repurchaseGiftCardResultCode", response?.result?.repurchaseGiftCardResultCode, (24 * 60 * 60));
    }
}